module.exports = __webpack_public_path__ + "img/VACUUM_AMENITY.85646b60.svg";